import { lazy } from "react";
import { UserCog } from "lucide-react";
import type { AdminModule } from "../types";

const Sessions = lazy(() => import("./pages/Sessions").then((m) => ({ default: m.Sessions })));
const History = lazy(() => import("./pages/History").then((m) => ({ default: m.History })));

/**
 * Oversight for the portal's most privileged capability.
 *
 * Starting a session already lived on the user page; seeing them did not. The
 * API exposed /impersonation/active and no screen called it, so the only view
 * of a session was in the tab that opened it. This is the surface that answers
 * "who is inside a customer account right now?" and "who has been?", and the
 * one place any session can be revoked.
 *
 * Filed under Operations rather than Customers: it is a control on staff, not
 * a tool for working a customer's data.
 */
export const impersonationModule: AdminModule = {
  key: "impersonation",
  label: "Impersonation",
  description: "Live customer-account sessions, who opened them, and a revoke switch.",
  group: "operations",
  icon: UserCog,
  requiredPermission: "admin.users.impersonate",
  routes: [
    { path: "active", label: "Active", element: <Sessions /> },
    { path: "history", label: "History", element: <History /> },
  ],
};
